import React, { useContext, useEffect, useState } from 'react'
import { UpdateWallet } from 'api/Wallet/Types/UpdateWallet'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { Spinner } from 'components/Spinner'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useAppDispatch, useAppSelector } from 'store'
import { getWalletRestrictionsAction, getWalletStatesAction } from 'store/wallet/wallet-actions'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { AuthSessionContext } from 'utils/AuthContext'
import { isEmpty } from 'utils/is-empty'

import ClientAreaAuditLogModal from '../../../components/ClientAreaAuditLogModal/ClientAreaAuditLogModal'
import { WalletDetailsForm } from './WalletDetailsForm'

interface Props {
  data: WalletDto
  forceRefresh(): void
}

const WalletDetailsPage: React.FC<Props> = ({ data, forceRefresh }) => {
  const [auth] = useContext(AuthSessionContext)
  const [auditLogVisible, setAuditLogVisible] = useState(false)

  const dispatch = useAppDispatch()
  const walletStates = useAppSelector((state) => state.wallet.states)
  const walletRestrictions = useAppSelector((state) => state.wallet.restrictions)

  const walletsApiClient = useApiClient(WalletsApiClient)
  useEffect(() => {
    if (isEmpty(walletStates)) dispatch(getWalletStatesAction(walletsApiClient))
    if (isEmpty(walletRestrictions)) dispatch(getWalletRestrictionsAction(walletsApiClient))
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const setToast = useContext(ToastContext)

  const onSubmit = async (values: UpdateWallet) => {
    try {
      await walletsApiClient.updateWallet(data.id, values)
      forceRefresh()
      setToast(successToast('Wallet update successfully.'))
    } catch (e) {
      console.error(e)
    }
  }

  if (!data) {
    return <Spinner />
  }

  return (
    <React.Fragment>
      {auditLogVisible && (
        <ClientAreaAuditLogModal
          isVisible={auditLogVisible}
          onClose={() => setAuditLogVisible(false)}
          walletId={data.id}
        />
      )}
      <WalletDetailsForm
        onSubmit={onSubmit}
        wallet={data}
        permissions={auth?.permissions || []}
        walletStates={walletStates}
        walletRestrictions={walletRestrictions}
        setAuditLogModal={() => setAuditLogVisible(true)}
      />
    </React.Fragment>
  )
}

export default WalletDetailsPage
